"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.AsyncRequestState = exports.useAsyncRequestState = void 0;
var react_1 = require("react");
/**
 * AsyncRequestState is an enum to describe the current loading state of
 * an async request.
 */
var AsyncRequestState;
(function (AsyncRequestState) {
    AsyncRequestState[AsyncRequestState["NEVER"] = 0] = "NEVER";
    AsyncRequestState[AsyncRequestState["LOADING"] = 1] = "LOADING";
    AsyncRequestState[AsyncRequestState["COMPLETE"] = 2] = "COMPLETE";
    AsyncRequestState[AsyncRequestState["ERROR"] = 3] = "ERROR";
})(AsyncRequestState || (AsyncRequestState = {}));
exports.AsyncRequestState = AsyncRequestState;
/**
 * A helper hook for components that need to make an async request, this wraps a request and returns it
 * for the user to decide when to execute the async request (e.g., a button click, or useEffect). It provides a common
 * interface to know what state the request is currently in:
 *  - not requested (NEVER)
 *  - LOADING
 *  - COMPLETE
 *  - ERROR
 * It returns response data, and catches and returns an error if there is one.
 */
var useAsyncRequestState = function (request) {
    var _a = (0, react_1.useState)(null), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)(AsyncRequestState.NEVER), requestState = _b[0], setRequestState = _b[1];
    var _c = (0, react_1.useState)(), error = _c[0], setError = _c[1];
    var wrappedRequest = function (reqParams) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRequestState(AsyncRequestState.LOADING);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, request(reqParams)];
                case 2:
                    response = _a.sent();
                    setData(response);
                    setError(undefined);
                    setRequestState(AsyncRequestState.COMPLETE);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setData(null);
                    /**
                     * FIXME: ideally we would be doing some smarter error type narrowing to validate
                     *        the shape instead of coercing it into `E. see https://github.com/eftours/cx-common-typescript/pull/60#pullrequestreview-1578858845
                     */
                    setError(e_1);
                    setRequestState(AsyncRequestState.ERROR);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return { request: wrappedRequest, requestState: requestState, error: error, data: data };
};
exports.useAsyncRequestState = useAsyncRequestState;
